import React from "react";
import { View, Text, Button, TextInput } from "ui";
import { styled } from "styles";
import { userMutations } from "api";
import { DataProps } from "types";
import { notify } from "shared/services";

interface S{
  message: string;
  name: string;
  email: string;
  phone: string;
}

export default class Contact extends React.Component<DataProps, S> {

  constructor(props){
    super(props);
    let state: any = { message : "" };

    if (this.props.currentUser){
      const user = this.props.currentUser;
      state.name = user.name || "";
      if (user.primary_phone_id){
        state.phone = user.phones.find(p => p.id === user.primary_phone_id).phone_number;
      } else {
        state.phone = "";
      }
      if (user.primary_email_id){
        state.email = user.emails.find(e => e.id === user.primary_email_id).email;
      } else {
        state.email = "";
      }
    }
    this.state = state;
  }
  public render = () => {
    const { message, name, email, phone } = this.state;
    return (
      <View p={2} flexDirection="column">
        <Text mb={2} alignSelf="center" fontWeight="bold" fontSize={5}>
          Contact
        </Text>
        <View flexDirection="column" alignSelf="center">
          {!this.props.currentUser && (
            <React.Fragment>
              <Input
                value={phone}
                onChange={e => this.setState({ phone: e.target.value })}
                mb={1}
                placeholder="Telefon"
              />
              <Input
                value={name}
                onChange={e => this.setState({ name: e.target.value })}
                mb={1}
                placeholder="Nume"
              />
              <Input
                value={email}
                onChange={e => this.setState({ email: e.target.value })}
                mb={1}
                placeholder="Email"
              />
            </React.Fragment>
          )}
          <Message
            small={!this.props.currentUser}
            value={message}
            onChange={e => this.setState({ message: e.target.value })}
            placeholder="Mesajul Tau"
          />
        </View>
        <userMutations.Contact>
          {contact => (
            <Submit
              onClick={async () => {
                await contact({ variables: { name, message, phone, email } });
                notify("Mesajul a fost trimis.");
              }}
              alignSelf="center"
              mt={2}
              bg="primary"
              color="white"
            >
              <Text fontWeight="bold" fontSize={4}>
                Trimite Mesaj
              </Text>
            </Submit>
          )}
        </userMutations.Contact>
      </View>
    );
  }
}

const Input = styled(TextInput)`
  font-size: 1.5rem;
  outline: none;
  border: 1px solid;
  border-color: black;
  border-radius: 10px;
  padding-left: 1rem;
  padding-right: 1rem;
  resize: none;
`;
const Message = styled.textarea<{ small?: boolean }>`
  min-height: ${p => (p.small ? "10rem" : "20rem")};
  min-width: 25rem;
  font-size: 1.5rem;
  outline: none;
  border: 1px solid;
  border-color: black;
  border-radius: 10px;
  padding: 1rem;
  resize: none;
`;

const Submit = styled(Button)`
  min-width: 25rem;
`;



// WEBPACK FOOTER //
// ./src/pages/Contact.tsx